import RecorderProcessor from './Recorder.worklet';
import { AudioContext, AudioWorkletNode } from 'standardized-audio-context';
const defaultVideoOptions = {
    screen: false,
    camera: false,
};
const defaultAudioOptions = {
    microphone: false,
};
/**
 * Media recorder that is able to record audio
 */
export class MediaRecorder {
    constructor(options) {
        var _a, _b;
        this.initialize = (options) => {
            var _a;
            this.chunks = [];
            this.setState('inactive');
            this.onData = (_a = options.onData) !== null && _a !== void 0 ? _a : (() => { });
        };
        this.initializeAudioContext = async (stream) => {
            var _a;
            const context = new AudioContext(this.audio.sampleRate ? { sampleRate: this.audio.sampleRate } : {});
            const source = context.createMediaStreamSource(stream);
            await ((_a = context.audioWorklet) === null || _a === void 0 ? void 0 : _a.addModule(RecorderProcessor));
            const recorder = new AudioWorkletNode(context, 'recorder');
            source.connect(recorder).connect(context.destination);
            return { context, recorder };
        };
        this.setState = (state) => (this.state = state);
        this.start = async (onMuted) => {
            try {
                this.stream = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                });
                const { context, recorder } = await this.initializeAudioContext(this.stream);
                this.context = context;
                this.audioNode = recorder;
                this.setState('recording');
                recorder.port.onmessage = (e) => {
                    var _a;
                    const data = e.data;
                    this.chunks.push(data);
                    this.onData(data);
                    if ((_a = this.stream) === null || _a === void 0 ? void 0 : _a.getAudioTracks()[0].muted) {
                        if (onMuted) {
                            onMuted(true);
                        }
                    }
                    else {
                        if (onMuted) {
                            onMuted(false);
                        }
                    }
                };
                return { started: true };
            }
            catch (e) {
                this.setState('unavailable');
                return { started: false, error: e };
            }
        };
        this.pause = async () => {
            if (this.context && this.context.state !== 'suspended') {
                await this.context.suspend();
            }
            this.setState('paused');
        };
        this.resume = async () => {
            if (this.context && this.context.state !== 'running') {
                await this.context.resume();
            }
            this.setState('recording');
        };
        this.stop = async () => {
            if (this.audioNode) {
                this.audioNode.disconnect();
                this.audioNode = undefined;
            }
            if (this.context && this.context.state !== 'closed') {
                await this.context.close();
                this.context = undefined;
            }
            if (this.stream) {
                this.stream.getTracks().forEach((track) => track.stop());
                this.stream = undefined;
            }
            this.setState('inactive');
            this.chunks = [];
        };
        this.requestData = () => this.chunks;
        const video = Object.assign(Object.assign({}, defaultVideoOptions), ((_a = options.video) !== null && _a !== void 0 ? _a : {}));
        this.audio = Object.assign(Object.assign({}, defaultAudioOptions), ((_b = options.audio) !== null && _b !== void 0 ? _b : {}));
        if (video.camera || video.screen) {
            throw new Error('video is currently not supported');
        }
        if (!this.audio.microphone) {
            throw new Error('Either audio or video options should be set');
        }
        if (!window.isSecureContext) {
            throw new Error('Not supported in an insecure context');
        }
        this.initialize(options);
    }
    get sampleRate() {
        var _a;
        return (_a = this.context) === null || _a === void 0 ? void 0 : _a.sampleRate;
    }
    get mediaStream() {
        return this.stream;
    }
}
